// AB#60403, AB#60662 — Guard mid-flow join step pages against out-of-flow direct visits.
//
// Runs on both server and client (SSR-safe) — no import.meta.client guard needed
// because useCookie() resolves from the request cookie header on the server and from
// document.cookie on the client.
//
// The isRecruit cookie (set by setRecruitCookie() in auth.ts) is the sole signal that
// a join session is in progress. Cookie absent or not 'true' → bounce to /join.
// Finer per-step checks (store hydration from the backend /join record) live in each
// step page's onMounted via hydrateSession().
import { JOIN_ROOT } from '~/utils/joinRoutes'

export default defineNuxtRouteMiddleware(() => {
  // useCookie() runs the value through destr(), so an `isRecruit=true` cookie
  // resolves to the BOOLEAN `true` on the server (it'd be the string 'true'
  // only if read raw). Comparing against the literal string 'true' is therefore
  // always false on SSR, which would redirect every valid recruit back to /join
  // on a hard refresh. Compare on truthiness instead.
  const isRecruit = useCookie('isRecruit')
  if (!isRecruit.value) {
    return navigateTo(JOIN_ROOT)
  }
})
